const updates = [
  {
    date: '2026-07-29',
    tag: '最新更新',
    title: '《霸道总裁的契约新娘》第128话上线',
    desc: '热门韩漫最新话，布丁漫画下拉式连续阅读现已更新，总裁与新娘的感情线迎来重大转折。',
  },
  {
    date: '2026-07-28',
    tag: '新作上架',
    title: '《剑与魔法的咏叹调》全集登陆布丁漫画网',
    desc: '日漫人气作品全集一次性上架，支持布丁漫画连续阅读模式，从第1话到最终话一气呵成。',
  },
  {
    date: '2026-07-27',
    tag: '热门连载',
    title: '《修仙大佬在都市》第205话更新',
    desc: '国漫头部作品持续日更，布丁漫画全集免费阅读，修仙与都市的碰撞越来越精彩。',
  },
  {
    date: '2026-07-26',
    tag: '平台公告',
    title: '下拉式阅读体验全面升级',
    desc: '布丁漫画网优化了滚动加载引擎，布丁漫画下拉式阅读速度提升40%，长章节加载更流畅。',
  },
  {
    date: '2026-07-25',
    tag: '新作上架',
    title: '《甜蜜的陷阱》韩漫全集上线',
    desc: '甜宠悬疑题材韩漫，布丁漫画下拉式免费看全集，反转剧情让读者直呼过瘾。',
  },
  {
    date: '2026-07-24',
    tag: '热门连载',
    title: '《末日生存指南》第89话更新',
    desc: '末日题材国漫持续火爆，布丁漫画连续阅读模式让追更体验更加沉浸。',
  },
  {
    date: '2026-07-23',
    tag: '平台公告',
    title: '布丁漫画网日漫频道全新改版',
    desc: '日漫分类页面优化，新增按作者、题材筛选功能，布丁漫画全集分类更清晰。',
  },
  {
    date: '2026-07-22',
    tag: '最新更新',
    title: '《重生之豪门千金》第312话更新',
    desc: '长篇韩漫持续更新中，布丁漫画下拉式免费看，剧情进入最终章高潮部分。',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            实时动态
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">
            更新快讯
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            布丁漫画网每日更新动态，不错过任何一部热门作品的最新进展
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] md:left-1/2 top-0 bottom-0 w-px bg-background-200 -translate-x-1/2 hidden md:block"></div>

          <div className="flex flex-col gap-6">
            {updates.map((item, idx) => (
              <div
                key={idx}
                className={`flex flex-col md:flex-row gap-4 md:gap-8 ${
                  idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                <div className={`flex-1 ${idx % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
                  <div
                    className={`bg-background-100 border border-background-200/70 rounded-2xl p-5 md:p-6 hover:border-primary-200 transition-all duration-300 ${
                      idx % 2 === 0 ? 'md:mr-0' : 'md:ml-0'
                    }`}
                  >
                    <div className="flex items-center gap-3 mb-3 flex-wrap">
                      <span className="text-xs text-foreground-400">{item.date}</span>
                      <span className="px-2.5 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
                        {item.tag}
                      </span>
                    </div>
                    <h3 className="text-base font-semibold text-foreground-900 mb-2">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>

                <div className="hidden md:flex items-center justify-center w-10 flex-shrink-0">
                  <div className="w-3 h-3 rounded-full bg-primary-500 ring-4 ring-primary-100"></div>
                </div>

                <div className="flex-1 hidden md:block"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}